import { useEffect, useState } from "react";
import { Mic, Loader2, Search } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;
const auth = () => ({ Authorization: `Bearer ${localStorage.getItem("reclaim_token")}` });

const Row = ({ r }) => (
  <div className="flex items-center justify-between text-xs py-2 border-t border-[#F0EDE8]" data-testid={`voice-row-${r.id}`}>
    <div className="min-w-0">
      <div className="font-medium text-[#292524] truncate">{r.name}</div>
      <div className="text-[#78716C] truncate">{r.user?.email} · {r.audio_status} · {(r.created_at || "").slice(0, 10)}</div>
    </div>
    <span className={`shrink-0 ml-3 px-2 py-0.5 rounded-full ${r.voice_missing ? "bg-red-50 text-red-700" : "bg-green-50 text-green-700"}`}>
      own voice {r.voice_overrides_count}/{r.recordings_available}
    </span>
  </div>
);

export const VoiceMissesPanel = () => {
  const [misses, setMisses] = useState([]);
  const [q, setQ] = useState("");
  const [found, setFound] = useState(null);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");

  const loadMisses = async () => {
    const r = await fetch(`${API}/api/admin/journey-diagnostics/voice-misses`, { headers: auth() });
    if (r.ok) setMisses((await r.json()).items || []);
  };
  useEffect(() => { loadMisses(); }, []);

  const search = async () => {
    if (q.trim().length < 2) return;
    const r = await fetch(`${API}/api/admin/journey-diagnostics/search?q=${encodeURIComponent(q.trim())}`, { headers: auth() });
    setFound(r.ok ? (await r.json()).items : []);
  };

  const rerenderAll = async () => {
    setBusy(true);
    try {
      const r = await fetch(`${API}/api/admin/journey-diagnostics/voice-misses/rerender`, { method: "POST", headers: auth() });
      const d = await r.json();
      setMsg(`Re-rendering ${d.kicked?.length || 0} install(s) with the user's own voice${d.errors?.length ? ` · ${d.errors.length} error(s)` : ""}`);
      await loadMisses();
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="bg-white border border-[#E6E2DD] rounded-xl p-4" data-testid="voice-misses-panel">
      <div className="flex items-center justify-between mb-2">
        <h2 className="text-sm font-semibold text-[#292524] flex items-center gap-2"><Mic size={14} /> Own-voice check</h2>
        <button onClick={rerenderAll} disabled={busy || !misses.length} data-testid="voice-misses-rerender-btn"
          className="text-xs px-3 py-1.5 rounded-full bg-[#4A6741] text-white disabled:opacity-40 flex items-center gap-1">
          {busy && <Loader2 size={12} className="animate-spin" />} Re-render {misses.length} with own voice
        </button>
      </div>
      <p className="text-xs text-[#78716C] mb-2" data-testid="voice-misses-count">
        {misses.length} ready install(s) in the last 30 days where recorded lines weren't used in the audio.
      </p>
      {msg && <p className="text-xs text-amber-800 bg-amber-50 rounded p-2 mb-2" data-testid="voice-misses-msg">{msg}</p>}
      {misses.map((r) => <Row key={r.id} r={r} />)}
      <div className="flex items-center gap-2 mt-3">
        <Search size={14} className="text-[#78716C]" />
        <input value={q} onChange={(e) => setQ(e.target.value)} onKeyDown={(e) => e.key === "Enter" && search()}
          placeholder="Find install by name…" className="flex-1 text-xs outline-none" data-testid="voice-search-input" />
        <button onClick={search} className="text-xs text-[#4A6741]" data-testid="voice-search-btn">Search</button>
      </div>
      {found && (found.length ? found.map((r) => <Row key={r.id} r={r} />)
        : <p className="text-xs text-[#78716C] mt-2" data-testid="voice-search-empty">No installs match.</p>)}
    </div>
  );
};
